import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputHelperText from '../InputHelperText';
import InputLabel from '../InputLabel';
import Select from '../Select';
import SelectFieldItem from './SelectFieldItem';
import useStyles from './SelectField.styles';
export const SelectField = ({ label, value = '', error = false, disabled = false, helperText = '', onChange = () => {
    return;
}, onBlur = () => {
    return;
}, children, testId, native = true, maxWidth, displayEmpty, renderValue, }) => {
    const classes = useStyles();
    return (_jsxs("div", Object.assign({ className: classes.root, style: { maxWidth } }, { children: [_jsx(InputLabel, Object.assign({ error: error, disabled: disabled }, { children: label })), _jsx(Select, Object.assign({ fullWidth: true, value: value, disabled: disabled, onChange: onChange, onBlur: onBlur, testId: testId, native: native, displayEmpty: displayEmpty, renderValue: renderValue }, { children: children })), helperText && (_jsx(InputHelperText, Object.assign({ indent: true, error: error, disabled: disabled }, { children: helperText })))] })));
};
export default Object.assign(SelectField, {
    Item: SelectFieldItem,
});
//# sourceMappingURL=SelectField.js.map